// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Classes */\n.side-menu {\n    background-color: #f2f2f2;\n    position: fixed;\n    z-index: 9;\n    min-height: 100%;\n    width: 300px;\n    border-right: 1px solid #dfe2e6;\n}", ""]);
// Exports
module.exports = exports;
